import { TAppUserState } from "@types";

const STORE_NAME = "BNPSERVICE";
const ADMIN_STORE_NAME = "BNPSERVICE_ADMIN";

const getItem = (key: string) => {
  if (typeof sessionStorage !== "undefined") {
    return sessionStorage.getItem(key);
  }
  return null;
};

const setItem = (key: string, value: string) => {
  if (typeof sessionStorage !== "undefined") {
    sessionStorage.setItem(key, value);
  }
};

const removeItem = (key: string) => {
  if (typeof sessionStorage !== "undefined") {
    sessionStorage.removeItem(key);
  }
};

export const loadStore = () => {
  try {
    const serializedState: any = getItem(STORE_NAME);
    const state: TAppUserState = JSON.parse(serializedState);
    return state;
  } catch (err) {
    console.log(err);
    return undefined;
  }
};

export const saveStore = (state: TAppUserState) => {
  try {
    const serializedState = JSON.stringify({
      ...state,
      loginTime: new Date().getTime(),
    });
    setItem(STORE_NAME, serializedState);
  } catch (err) {
    console.log(err);
  }
};

export const deleteStore = () => {
  try {
    removeItem(STORE_NAME);
  } catch (err) {
    console.log(err);
  }
};

export const loadAdminStore = () => {
  try {
    const serializedState: any = getItem(ADMIN_STORE_NAME);
    const state: TAppUserState = JSON.parse(serializedState);
    return state;
  } catch (err) {
    console.log(err);
    return undefined;
  }
};

export const saveAdminStore = (state: TAppUserState) => {
  try {
    const serializedState = JSON.stringify({
      ...state,
      loginTime: new Date().getTime(),
    });
    setItem(ADMIN_STORE_NAME, serializedState);
  } catch (err) {
    console.log(err);
  }
};

export const deleteAdminStore = () => {
  try {
    removeItem(ADMIN_STORE_NAME);
  } catch (err) {
    console.log(err);
  }
};
